import * as React from "react";
import * as cn from "classnames/bind";
import * as styles from "./login-box.css";
import { useState } from "react";
import Button from "content/button/button";
import { resetPassword } from "page/user/service";

const cx = cn.bind(styles);

type ResetFormProps = {
    getResource: (key: string) => string;
    swapToLoginClicked: () => any;
};

const labelCn = () =>
    cx({
        label: true,
    });

const errorLabelCn = () =>
    cx({
        label: true,
        errorLabel: true,
    });

const inputBoxCn = (hasErrors: boolean) =>
    cx({
        input: true,
        inputWithError: hasErrors,
    });

const aTagCn = () =>
    cx({
        aTag: true,
    });

const ResetForm: React.SFC<ResetFormProps> = (props) => {
    const [userName, setUserName] = useState("");
    const [userNameErrorText, setUserNameErrorText] = useState<string | null>(
        "",
    );
    const [resetMailSent, setResetMailSent] = useState(false);

    const { getResource } = props;

    const isFormValid = () => {
        let userNameError = null;

        const mailRx = /\S+@\S+\.\S+/;

        if (!userName || userName === "") {
            userNameError = getResource("ResetForm_Error_MissingEmail");
        } else if (!mailRx.test(userName)) {
            userNameError = getResource("ResetForm_Error_WrongEmail");
        }

        setUserNameErrorText(userNameError);

        if (userNameError) {
            return false;
        }

        return true;
    };

    const resetClicked = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (isFormValid()) {
            const result = await resetPassword(userName);

            const { success, data, message, status } = result;

            if (success) {
                setResetMailSent(true);
            }
        }
    };

    const putFormToInitialState = () => {
        setResetMailSent(false);
        setUserName("");
    };

    return (
        <form>
            <h3>{getResource("ResetForm_Text_Header")} </h3>
            <p>{getResource("ResetForm_Text_Lead")}</p>
            {resetMailSent && (
                <div>
                    <strong>{getResource("ResetForm_Confirm_Message")} </strong>
                    <a className={aTagCn()} onClick={putFormToInitialState}>
                        {getResource("ResetForm_Confirm_NewReset")}
                    </a>
                </div>
            )}
            {!resetMailSent && (
                <>
                    <label className={labelCn()}>
                        {getResource("ResetForm_Form_Email")}
                    </label>
                    <input
                        className={inputBoxCn(!!userNameErrorText)}
                        type="email"
                        required={true}
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                    />
                    <label className={errorLabelCn()}>
                        {userNameErrorText}
                    </label>
                    <Button
                        text={getResource("ResetForm_Button_Reset")}
                        width={"100%"}
                        onClick={resetClicked}
                    />
                </>
            )}

            <div>
                <br />
                {getResource("ResetForm_Back_Text")}{" "}
                <strong>
                    <a
                        style={{ cursor: "pointer" }}
                        onClick={props.swapToLoginClicked}>
                        {" "}
                        {getResource("ResetForm_Back_Clickhere")}
                    </a>
                </strong>
            </div>
        </form>
    );
};

export default ResetForm;
